export enum UnsupportedBrowsers {
  Firefox = "Firefox",
}
